export default state => ({
  ...state,
  address: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    zipCode: '',
  },
  validationResult: {},
  windowCategoryMappings: { 0: {} },
});
